import {Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {Usuario} from '../../shared/model/usuario/usuario.model';
import {CelularMaskPipe} from '../../shared/pipe/celular-mask.pipe';
import {ImagensUsuarioPerfilModel} from '../../shared/model/usuario/imagens-usuario-perfil.model';
import {environment} from '../../../../environments/environment';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-info-usuario',
  standalone: true,
  imports: [
    CelularMaskPipe
  ],
  templateUrl: './info-usuario.component.html',
  styleUrl: './info-usuario.component.css'
})
export class InfoUsuarioComponent implements OnChanges {

  _imgUsuario: ImagensUsuarioPerfilModel = new ImagensUsuarioPerfilModel();
  @Input() usuario: Usuario = new Usuario();

  @Input()
  set imgUsuario(value: ImagensUsuarioPerfilModel) {
    this._imgUsuario = value;
    this.gerarUrlImg();
  }

  @Output() envioImagem = new EventEmitter<ImagensUsuarioPerfilModel>();


  private readonly domSanitizer = inject(DomSanitizer);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['usuario']) {
      this.gerarUrlImg();
    }
  }

  gerarUrlImg(): SafeUrl {
    if(this._imgUsuario.imgUsuario){
      this.usuario.extensaoImg = this._imgUsuario.extensaoImg;
      return this._imgUsuario.imgUsuario;
    }
    else{
      return this.domSanitizer.bypassSecurityTrustUrl(`${environment.urlRepositorioClaribot}/${this.usuario.grupo?.id}/usuario-img/${this.usuario.uuid}.${this.usuario.extensaoImg}`);
    }
  }

  selecionarFotoUsuario(event: any) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target?.files[0]);
    reader.onload = () => {
      if(reader.result) {
        this._imgUsuario.imgUsuario = this.domSanitizer.bypassSecurityTrustUrl(reader.result.toString());
        this._imgUsuario.imgBase64 = reader.result.toString().split(';base64,')[1];
        this._imgUsuario.extensaoImg = reader.result.toString().split(';base64,')[0].split('/')[1];
        this.envioImagem.emit(this._imgUsuario);
      }
    };
  }

}
